import {
  createFileRoute,
  Outlet,
  useRouterState,
} from "@tanstack/react-router";
import { useEffect } from "react";
import { setMlFrontendRouteSentryContext } from "../lib/sentry";
import "../styles.css";

function MlFrontendLayout() {
  const pathname = useRouterState({
    select: (state) =>
      state.resolvedLocation?.pathname ?? state.location.pathname,
  });

  useEffect(() => {
    setMlFrontendRouteSentryContext(pathname);
  }, [pathname]);

  return (
    <main className="min-h-screen bg-surface py-(--spacing-32)">
      <Outlet />
    </main>
  );
}

export const Route = createFileRoute("/_app")({
  component: MlFrontendLayout,
});
